import { applyPromptQueueStateFromServer } from '../../prompt-turn-queue/runner.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handlePromptQueueStateMessage: BridgeMessageHandler<'prompt_queue_state'> = (msg, deps) => {
  void applyPromptQueueStateFromServer(msg, deps).catch((err) => {
    deps.log(`[Queue] applyPromptQueueStateFromServer failed: ${err instanceof Error ? err.message : String(err)}`);
  });
};
